// The data in these objects are used by react-virtualized to render the column headers and cells.
// More info here: https://github.com/bvaughn/react-virtualized/blob/master/docs/Column.md

export const COLUMNS = [
  {
    width: 56,
    flexShrink: 0,
    label: "",
    dataKey: "checked",
    fixedWidth: true,
    disableSort: true,
  },
  {
    width: 248,
    fixedWidth: true,
    flexShrink: 0,
    label: "Event Name",
    dataKey: "name",
    columnData: {
      toolTip:
        "The name of the event and how it will be labeled in destinations.",
    },
  },
  {
    width: 148,
    fixedWidth: true,
    flexShrink: 0,
    label: "Event Type",
    dataKey: "type",
    columnData: {
      toolTip:
        "The category of the event. Categories are based on the type of user interaction or the origin of the event.",
    },
  },
  {
    width: 188,
    fixedWidth: true,
    flexShrink: 0,
    label: "Destinations",
    dataKey: "destinations",
    disableSort: true,
    columnData: {
      toolTip: "The destinations these events will be sent to.",
    },
  },
  {
    width: 188,
    fixedWidth: true,
    flexShrink: 0,
    label: "Tags",
    dataKey: "tags",
    disableSort: true,
    columnData: {
      toolTip:
        "Tags are used to group events together and can be used to filter events.",
    },
  },
  {
    width: 280,
    minWidth: 280,
    label: "Description",
    dataKey: "description",
    columnData: {
      toolTip:
        "A description of the event that explains where the event came from and how it is used.",
    },
  },
];
